import type { UserPlan } from "@unranked/shared";
import { useCallback, useEffect, useState } from "react";
import { apiFetch } from "./api";

export function usePlan() {
	const [plan, setPlan] = useState<UserPlan | null>(null);
	const [loading, setLoading] = useState(true);

	const refresh = useCallback(async () => {
		try {
			const data = await apiFetch<UserPlan>("/api/tier");
			setPlan(data);
		} catch {
			setPlan(null);
		} finally {
			setLoading(false);
		}
	}, []);

	useEffect(() => {
		refresh();
	}, [refresh]);

	return { plan, loading, refresh };
}
